import { render, staticRenderFns } from "./AccessDataPage.vue?vue&type=template&id=18225f90&"
import script from "./AccessDataPage.vue?vue&type=script&lang=js&"
export * from "./AccessDataPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports